module.exports = __webpack_public_path__ + "img/discoverability-2.65110409.png";